import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ pagination, loading, onPageChange }) => {
    if (!pagination || pagination.totalPages <= 1) return null;

    return (
        <div className="card-footer py-3">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                <small className="text-muted fw-medium font-size-13">
                    Showing <span className="text-dark">{((pagination.page - 1) * pagination.limit) + 1}</span> to <span className="text-dark">{Math.min(pagination.page * pagination.limit, pagination.totalRecords)}</span> of <span className="text-dark">{pagination.totalRecords}</span> transactions
                </small>
                <div className="d-flex align-items-center gap-3">
                    <button
                        className="btn btn-sm btn-outline-secondary px-3 d-flex align-items-center gap-1"
                        onClick={() => onPageChange(pagination.page - 1)}
                        disabled={pagination.page <= 1 || loading}
                    >
                        <ChevronLeft size={14} /> Previous
                    </button>
                    <span className="text-sm text-nowrap px-2 fw-semibold">
                        {pagination.page} <span className="text-muted fw-normal mx-1">of</span> {pagination.totalPages}
                    </span>
                    <button
                        className="btn btn-sm btn-outline-secondary px-3 d-flex align-items-center gap-1"
                        onClick={() => onPageChange(pagination.page + 1)}
                        disabled={pagination.page >= pagination.totalPages || loading}
                    >
                        Next <ChevronRight size={14} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Pagination;
